import React, {Fragment, useEffect, useState} from "react";
import queryString from 'query-string'
import {useLocation} from 'react-router-dom'

import './ChildDashboardTab.scss';
import DashboardPanelChildPostsReceived from "root/dashboard/DashboardPanelChildPostsReceived";
import DashboardPanelChildPostsSent from "root/dashboard/DashboardPanelChildPostsSent";
import DashboardPanelChildMessagesReceived from "root/dashboard/DashboardPanelChildMessagesReceived";
import DashboardPanelChildMessagesSent from "root/dashboard/DashboardPanelChildMessagesSent";
import DashboardPanelChildLogins from "root/dashboard/DashboardPanelChildLogins";
import DashboardPanelChildDiary from "root/dashboard/DashboardPanelChildDiary";
import {getMonthName} from "root/DataFunctions/DashboardDataFns"
import {useSetRecoilState} from "recoil";
import {childNameAtom} from "root/recoil/childName";
import {getChildDetails} from "root/DataFunctions/ChildDataFns";
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";

const ChildDashboardTab = (props) =>
{
    const d = new Date();
    const currentMonth = d.getMonth();
    const currentYear = d.getFullYear();
    const [month, setMonth] = useState(currentMonth);
    const [year, setYear] = useState(currentYear);
    const {search} = useLocation()
    const queryParams = queryString.parse(search);

    //Get child's data and set the global child name used by the various body header
    const setChildName = useSetRecoilState(childNameAtom);

    useEffect(() => {
        getChildData();
    }, [props.child_uid]);

    const getChildData = () =>{
        if(props.child_uid !== undefined)
        {
            getChildDetails(props.child_uid, (response) =>
            {
                let childData = getDataFromResponse(response)[0];
                // Set the recoil childNameAtom to the first child
                setChildName(childData.firstname + " " + childData.surname);
            });
        }
    }

    const displayPanel = () =>
    {
        switch (queryParams.type)
        {
            case 'posts-received':
                return <DashboardPanelChildPostsReceived child_uid={props.child_uid} title={'Posts Received'} year={year} month={month+1}/>
                break;

            case 'posts-sent':
                return <DashboardPanelChildPostsSent child_uid={props.child_uid} title={'Posts Sent'} year={year} month={month+1}/>
                break;
            
            case 'messages-received':
                return <DashboardPanelChildMessagesReceived child_uid={props.child_uid} title={'Messages Received'} year={year} month={month+1}/>
                break;

            case 'messages-sent':
                return <DashboardPanelChildMessagesSent child_uid={props.child_uid} title={'Messages Sent'} year={year} month={month+1}/>
                break;

            case 'logins':
                return <DashboardPanelChildLogins child_uid={props.child_uid} title={'Logins'} year={year} month={month+1}/>
                break;

            case 'diary':
                return <DashboardPanelChildDiary child_uid={props.child_uid} title={'Child Diary Entries'} year={year} month={month+1}/>
                break;

            default:
                return <DashboardPanelChildLogins child_uid={props.child_uid} title={'Logins'} year={year} month={month+1}/>
                break;
        }
    }

    const onClickPrevious = () =>
    {
        if(month == 0){
            setMonth(11);
            setYear(curYear=> curYear - 1);
        }
        else{
            setMonth(curMonth=> curMonth - 1);
        }
    }

    const onClickNext = () =>
    {
        if(month == 11){
            setMonth(0);
            setYear(curYear=> curYear + 1);
        }
        else{
            setMonth(curMonth=> curMonth + 1);
        }
    }

    const displayDateString = () =>{
        let monthName = getMonthName(month);
        let monthString = monthName + ' ' + year;
        return <div>{monthString}</div>
    }

    return (
        <Fragment>
            <div className="family-body">
                {displayPanel()}
            </div>

            {/* Month Buttons*/}
            {(queryParams.type !== 'logins' && queryParams.type !== 'posts-sent') &&
                <div className="d-flex flex-row justify-content-end">
                    <div className="family-body">
                        {displayDateString()}
                    </div>

                    <div className="p-2">
                        <button onClick={onClickPrevious} className="btn btn-primary">-<i
                            className="et-arrow-bold-left"></i></button>
                    </div>
                    <div className="p-2">
                        <button onClick={onClickNext} className="btn btn-primary">+<i
                            className="et-arrow-bold-left"></i></button>
                    </div>
                </div>
            }
        </Fragment>
    )
}

ChildDashboardTab.defaultProps = {};

export default ChildDashboardTab;


